module.exports = "pegasus_template/assets/mountains-nature-sky-sunny.png";